import React, { useState, useEffect, useRef } from "react";
import {
    Typography,
    Divider,
    IconButton,
    Box,
    Button,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    FormHelperText,
    TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { MascaraCnpj } from "../../../utils/MascaraCnpj";
import { MascaraTelefone } from "../../../utils/MascaraTelefone";
import { MascaraCep } from "../../../utils/MascaraCep";
import { TirarMascara } from "../../../utils/TirarMascara"
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs, Link } from "@mui/material";

// Ícones
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import EmailIcon from "@mui/icons-material/Email";
import Select from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';

// Componentes personalizados
import HeaderDashboard from "../../components/HeaderDashboard";
import ModalNotificacao from "./ModalNotificacao";
import Loading from "../../components/Loading";

// Contexto
import { useUser } from "../../../contexts/UserContext";
import AlertSuccess from "../../components/AlertSuccess";
import AlertError from "../../components/AlertError";

const Certificado = () => {
    const { user } = useUser();
    const navigate = useNavigate();

    // Estados gerais
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [hasCertificado, setHasCertificado] = useState(false);
    const [open, setOpen] = useState(false);
    const [certificadoName, setCertificadoName] = useState(null);
    const [razaoSocial, setRazaoSocial] = useState("");
    const [nomeFantasia, setNomeFantasia] = useState("");
    const [cep, setCep] = useState("");
    const [endereco, setEndereco] = useState("");
    const [numero, setNumero] = useState("");
    const [estado, setEstado] = useState("");
    const [cidade, setCidade] = useState("");
    const [bairro, setBairro] = useState("");
    const [telefone, setTelefone] = useState("");
    const [checkboxFatura, setCheckboxFatura] = useState(false);
    const [inscricaoMunicipal, setInscricaoMunicipal] = useState("");
    const [inscricaoEstadual, setInscricaoEstadual] = useState("");
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [mensagem, setMensagem] = useState("");
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [serie, setSerie] = useState("");
    const [numeroNota, setNumeroNota] = useState("");
    const [erroSerie, setErroSerie] = useState(false);
    const [erroNumeroNota, setErroNumeroNota] = useState(false);

    const [erroCnpj, setErroCnpj] = useState(false);
    const [erroRazaoSocial, setErroRazaoSocial] = useState(false);
    const [erroSimplesNacional, setErroSimplesNacional] = useState(false);
    const [erroRegimeTributario, setErroRegimeTributario] = useState(false);
    const [erroRegimeTributarioEspecial, setErroRegimeTributarioEspecial] = useState(false);
    const [erroCep, setErroCep] = useState(false);
    const [erroInscricaoMunicipal, setErroInscricaoMunicipal] = useState(false);
    const [erroNomeFantasia, setErroNomeFantasia] = useState(false);

    // Campos de formulário
    const [email, setEmail] = useState("");
    const [file, setFile] = useState(null);
    const [senha, setSenha] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    // Campos de formulário
    const [cnpj, setCnpj] = useState("");

    // Drag & Drop
    const [isDragging, setIsDragging] = useState(false);
    const fileInputRef = useRef(null);

    const token = localStorage.getItem("token");

    // Busca e-mail do usuário logado
    useEffect(() => {
        if (user?.usuario?.Email) setEmail(user.usuario.Email);
    }, [user]);

    // Busca certificado ativo
    useEffect(() => {
        const getCertificado = async () => {
            setOpen(true);
            try {
                const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/getCertificado`, {
                    headers: { Authorization: token },
                });
                console.log("Dados do certificado:", data);
                setHasCertificado(data.status === 200);
                if (data.status === 200) {
                    setCertificadoName(data.certificado.arquivoNome);
                }
            } catch (err) {
                console.error("Erro ao buscar certificado:", err);
                setHasCertificado(false);
            } finally {
                setOpen(false);
            }
        };

        getCertificado();
    }, [token]);

    // Funções de drag and drop
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => setIsDragging(false);

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const droppedFile = e.dataTransfer.files[0];
        validateFile(droppedFile);
    };

    const handleFileSelect = (e) => {
        const selectedFile = e.target.files[0];
        validateFile(selectedFile);
    };

    const validateFile = (file) => {
        if (file && (file.name.endsWith(".pfx") || file.name.endsWith(".p12"))) {
            setFile(file);
        } else {
            alert("Por favor, selecione um arquivo .pfx ou .p12 válido.");
        }
    };

    // Controle da visibilidade da senha
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => event.preventDefault();

    // Envio do certificado
    const handleSubmit = async () => {
        if (!file) {
            setMensagem("Selecione um arquivo de certificado.");
            setOpenSnackbarError(true);
            return;
        }
        if (!senha) {
            setMensagem("Digite a senha do certificado.");
            setOpenSnackbarError(true);
            return;
        }

        const formData = new FormData();
        formData.append("arquivo", file);
        formData.append("senha", senha);
        formData.append("email", email);

        try {
            setOpen(true);
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/uploadCertificado`, formData, {
                headers: {
                    Authorization: token,
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log("Resposta do upload:", data);
            if (data.status === 200) {
                setMensagem("Certificado atualizado com sucesso!");
                setOpenSnackbarSuccess(true);

                setHasCertificado(true);
                setCertificadoName(data.nomeArquivo);
            } else {
                setMensagem("Falha ao atualizar certificado. Verifique os dados e tente novamente.");
                setOpenSnackbarError(true);
            }
        } catch (err) {
            console.error(err);
            setMensagem("Erro ao enviar o certificado. Tente novamente mais tarde.");
            setOpenSnackbarError(true);
        } finally {
            setOpen(false);
        }
    };

    const handleCnpj = async (e) => {
        setCnpj(MascaraCnpj(e.target.value));
        if (e.target.value.length === 18) {
            setOpen(true);
            console.log(TirarMascara(e.target.value))
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/buscarCnpj/${TirarMascara(e.target.value)}`, {
                headers: { Authorization: token },
            });
            if (response.data.status === 200) {
                setRazaoSocial(response.data.data.razao_social);
                setNomeFantasia(response.data.data.nome);
                setCep(response.data.data.endereco.cep);
                setEndereco(response.data.data.endereco.logradouro);
                setNumero(response.data.data.endereco.numero);
                setEstado(response.data.data.endereco.uf);
                setCidade(response.data.data.endereco.municipio);
                setBairro(response.data.data.endereco.bairro);
                setTelefone(response.data.data.telefone);
                setOpen(false);
            } else {
                setOpen(false);
                alert("Cnpj não encontrado");
            }
            console.log(response);
        }
    }

    const handleSubmitCompany = async () => {
        let isValid = true;
        if (cnpj.length !== 18) {
            isValid = false;
            setErroCnpj(true);
        } else {
            setErroCnpj(false);
        }

        // if (inscricaoMunicipal.trim() === "") {
        //     isValid = false;
        //     setErroInscricaoMunicipal(true);
        // } else {
        //     setErroInscricaoMunicipal(false);
        // }

        if (serie.trim() === "") {
            isValid = false;
            setErroSerie(true);
        } else {
            setErroSerie(false);
        }
        if (numeroNota.trim() === "") {
            isValid = false;
            setErroNumeroNota(true);
        } else {
            setErroNumeroNota(false);
        }

        if (razaoSocial.trim() === "") {
            isValid = false;
            setErroRazaoSocial(true);
        } else {
            setErroRazaoSocial(false);
        }

        if (simplesNacional === "") {
            isValid = false;
            setErroSimplesNacional(true);
        } else {
            setErroSimplesNacional(false);
        }

        if (nomeFantasia.trim() === "") {
            isValid = false;
            setErroNomeFantasia(true);
        } else {
            setErroNomeFantasia(false);
        }

        if (regimeTributario === "") {
            isValid = false;
            setErroRegimeTributario(true);
        } else {
            setErroRegimeTributario(false);
        }

        if (regimeTributarioEspecial === "") {
            isValid = false;
            setErroRegimeTributarioEspecial(true);
        } else {
            setErroRegimeTributarioEspecial(false);
        }

        if (cep.trim() === "") {
            isValid = false;
            setErroCep(true);
        } else {
            setErroCep(false);
        }


        if (isValid) {
            setOpen(true);
            let objetoPlugNotas = {
                "cpfCnpj": cnpj.replace(/\D/g, ""),
                "inscricaoMunicipal": inscricaoMunicipal,
                "inscricaoEstadual": "", // inscricaoEstadual
                "razaoSocial": razaoSocial,
                "nomeFantasia": nomeFantasia,
                "certificado": null,
                "simplesNacional": simplesNacional,
                "regimeTributario": regimeTributario,
                "incentivoFiscal": incentivoFiscal,
                "incentivadorCultural": incentivoFiscalCultural,
                "regimeTributarioEspecial": regimeTributarioEspecial,
                "endereco": {
                    "tipoLogradouro": "",
                    "logradouro": endereco,
                    "numero": numero,
                    "complemento": "",
                    "tipoBairro": "",
                    "bairro": bairro,
                    "codigoPais": "1058",
                    "descricaoPais": "Brasil",
                    "codigoCidade": "",
                    "descricaoCidade": cidade,
                    "estado": estado,
                    "cep": cep.slice(0, 5) + "-" + cep.slice(5).trim(),
                },
                "telefone": {
                    "ddd": "",
                    "numero": telefone ? telefone.slice(4).trim() : ""
                },
                "email": email,
                "nfse": {
                    "ativo": true,
                    "tipoContrato": 0,
                    "config": {
                        "producao": true,
                        "nfseNacional": true,
                        "consultaNfseNacional": true,
                        "consultaDfe": {
                            "prestador": true,
                            "tomador": true,
                            "intermediario": true
                        },
                        "rps": {
                            "numero": Number(numeroNota), // que diabos é isso? numero do rps? se for, tem que ser automático
                            "serie": serie, // que diabos é isso? numero do rps? se for, tem que ser automático
                            "numeracaoAutomatica": true,
                            "agrupaLoteAutomatico": false,
                            "agrupaLoteComSerieAutomatico": false
                        },
                        "prefeitura": {
                            "login": "",
                            "senha": "",
                            "receitaBruta": 0,
                            "lei": "string",
                            "dataInicio": ""
                        },
                        "email": {
                            "envio": true
                        },
                        "calculoAutomaticoIbpt": {
                            "ativo": true
                        },
                        "enviarNotificacaoProcessamento": {
                            "webhook": true,
                            "email": true,
                            "destinatarios": []
                        }
                    }
                }
            }
            const objetoReq = {
                objetoPlugNotas,
                gerarFaturas: checkboxFatura,
            }

            const response = await axios.post(`${process.env.REACT_APP_API_URL}/salvarDadosEmpresa`, objetoReq, {
                headers: { Authorization: token },
            });
            if (response.data.status === 200) {
                setMensagem("Dados da empresa salvos com sucesso!");
                setOpenSnackbarSuccess(true);
                setOpen(false);
            } else {
                console.log(response.data);
                setMensagem("Falha ao salvar os dados da empresa. Verifique os dados e tente novamente.");
                setOpenSnackbarError(true);
                setOpen(false);
            }
        }
    }

    const [simplesNacional, setSimplesNacional] = useState('');
    const [regimeTributario, setRegimeTributario] = useState('');
    const [incentivoFiscal, setIncentivoFiscal] = useState(false);
    const [incentivoFiscalCultural, setIncentivoFiscalCultural] = useState(false);
    const [regimeTributarioEspecial, setRegimeTributarioEspecial] = useState('');

    return (
        <>
            <HeaderDashboard
                userActive={userActive}
                setOpenModalNotificacao={setOpenModalNotificacao}
                notificacoes={notificacoes.length}
            />
            <Box sx={{ p: 4, background: "#f4f6f8", minHeight: "100vh", mt: "64px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                    <div style={{ width: "80%" }}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                color="inherit"
                                onClick={() => navigate("../dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography
                                sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                            >
                                <ArtTrackIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Certificado & Empresa
                            </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <Box sx={{ width: window.innerWidth < 600 ? "100%" : "80%", mx: "auto" }}>
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 20, marginTop: 20 }}>
                        <Box
                            sx={{
                                width: window.innerWidth < 600 ? '100%' : '35%',
                                minWidth: 300,
                                height: "fit-content",
                                mx: "auto",
                                p: 3,
                                border: "1px solid #eee",
                                borderRadius: 2,
                                backgroundColor: "#fff",
                            }}
                        >
                            <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
                                Certificado Digital
                            </Typography>
                            <Divider sx={{ mb: 3 }} />


                            <Typography variant="body1" sx={{ mb: 2 }}>
                                <Box
                                    sx={{
                                        mb: 3,
                                        p: 3,
                                        borderRadius: "16px",
                                        border: "1px solid rgba(255,200,69,0.35)",
                                        background: "linear-gradient(135deg, #FFFDF5 0%, #FFF7D6 100%)",
                                        boxShadow: "0 8px 20px rgba(255, 200, 69, 0.12)",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 2,
                                            mb: 2,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 50,
                                                height: 50,
                                                borderRadius: "50%",
                                                background: "#ffc845",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "#fff",
                                            }}
                                        >
                                            <VerifiedUserIcon fontSize="large" />
                                        </Box>

                                        <Box>
                                            <Typography
                                                sx={{
                                                    fontWeight: 700,
                                                    fontSize: "1.1rem",
                                                    color: "#8a6100",
                                                }}
                                            >
                                                Certificado Digital
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: user?.certificado?.ativo ? "#2E7D32" : "#D32F2F",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                {user?.certificado?.ativo ? "● Ativo" : "● Inativo"}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box
                                        sx={{
                                            display: "grid",
                                            gridTemplateColumns: {
                                                xs: "1fr",
                                                md: "repeat(2, 1fr)",
                                            },
                                            gap: 2,
                                        }}
                                    >
                                        <Box>
                                            <Typography variant="caption" color="text.secondary">
                                                Titular
                                            </Typography>
                                            <Typography fontWeight={600}>
                                                {user?.certificado?.titular || "-"}
                                            </Typography>
                                        </Box>

                                        <Box>
                                            <Typography variant="caption" color="text.secondary">
                                                Emissor
                                            </Typography>
                                            <Typography fontWeight={600}>
                                                {user?.certificado?.emissor || "-"}
                                            </Typography>
                                        </Box>

                                        <Box>
                                            <Typography variant="caption" color="text.secondary">
                                                Data de Expiração
                                            </Typography>
                                            <Typography fontWeight={600}>
                                                {user?.certificado?.dataExpiracao
                                                    ? new Date(user.certificado.dataExpiracao).toLocaleDateString("pt-BR")
                                                    : "-"}
                                            </Typography>
                                        </Box>

                                        <Box>
                                            <Typography variant="caption" color="text.secondary">
                                                Status
                                            </Typography>
                                            <Typography
                                                fontWeight={700}
                                                color={user?.certificado?.ativo ? "success.main" : "error.main"}
                                            >
                                                {user?.certificado?.ativo ? "Ativo" : "Inativo"}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Typography>

                            {/* E-mail */}
                            <FormControl sx={{ mt: 3 }} fullWidth size="small" variant="outlined">
                                <InputLabel>E-mail para notificação</InputLabel>
                                <OutlinedInput
                                    value={user?.usuario?.Email || email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Digite seu e-mail"
                                    type="email"
                                    disabled
                                    autoComplete="off"
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <EmailIcon />
                                        </InputAdornment>
                                    }
                                    label="E-mail para notificação"
                                />
                                <FormHelperText>
                                    Enviaremos notificações para este e-mail quando o certificado estiver próximo do vencimento.
                                </FormHelperText>
                            </FormControl>

                            {/* Botão de envio */}
                            {/* <Button
                                fullWidth
                                variant="contained"
                                sx={{
                                    mt: 4,
                                    backgroundColor: "#901CB3",
                                    color: "white",
                                    fontWeight: 600,
                                    "&:hover": { backgroundColor: "#701d8aff" },
                                }}
                                disabled
                            >
                                Atualizar Certificado
                            </Button> */}
                        </Box>

                        <div style={{ width: window.innerWidth <= 600 ? '100%' : '60%', position: !hasCertificado ? "relative" : "" }}>
                            {!hasCertificado && (
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: 2,
                                        position: "absolute",
                                        inset: 0,
                                        backgroundColor: "rgba(128,128,128,0.4)", // cinza translúcido (melhor que background: "gray" + opacity)
                                        backdropFilter: "blur(1px)", // opcional: dá efeito "desativado"
                                        zIndex: 10,
                                        cursor: "not-allowed",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        px: 2,
                                        textAlign: "center",
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: "#000",
                                            fontWeight: 600,
                                            backgroundColor: "rgba(255,255,255,0.8)",
                                            p: 1.5,
                                            borderRadius: 1,
                                            boxShadow: "0 0 6px rgba(0,0,0,0.1)",
                                        }}
                                    >
                                        Antes de preencher os dados da empresa, é necessário cadastrar um
                                        certificado digital ativo.
                                    </Typography>
                                </Box>
                            )}

                            <Box
                                sx={{
                                    width: "100%",
                                    mx: "auto",
                                    opacity: hasCertificado ? 1 : 0.5,
                                    p: 3,
                                    border: "1px solid #eee",
                                    borderRadius: 2,
                                    backgroundColor: "#fff",
                                }}
                            >
                                <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
                                    Empresa
                                </Typography>
                                <Divider sx={{ mb: 2 }} />
                                <span style={{ color: "gray", fontSize: "0.75rem" }}>Aqui você acompanha as informações da sua empresa.</span>
                                <TextField fullWidth size="small" value={MascaraCnpj(user?.empresa?.cnpj) || ""} margin="dense" label="Cnpj da Empresa" variant="outlined" required placeholder="Digite o CNPJ da empresa" autoComplete="off" />
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, flexWrap: 'wrap' }}>
                                    <TextField style={{ width: window.innerWidth < 600 ? '100%' : '49%' }} disabled value={user?.empresa?.inscricaoEstadual || ""} size="small" margin="dense" label="Inscrição estadual" variant="outlined" autoComplete="off" />
                                    <TextField style={{ width: window.innerWidth < 600 ? '100%' : '49%' }} required value={user?.empresa?.inscricaoMunicipal || ""} size="small" margin="dense" label="Inscrição municipal" variant="outlined" autoComplete="off" />
                                </div>
                                <TextField fullWidth size="small" margin="dense" label="Razão Social da Empresa" value={user?.empresa?.razaoSocial || ""} variant="outlined" required placeholder="Digite a razão social da empresa" autoComplete="off" />
                                <TextField fullWidth size="small" margin="dense" label="Nome Fantasia da Empresa" value={user?.empresa?.nomeFantasia || ""} variant="outlined" placeholder="Digite o nome fantasia da empresa" autoComplete="off" />
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, flexWrap: 'wrap' }}>
                                    <FormControl fullWidth size="small" required style={{ width: window.innerWidth < 600 ? '100%' : '49%' }} margin="dense">
                                        <InputLabel id="demo-simple-select-label">Regime Tributário</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={user?.empresa?.taxRegime || ""}
                                            label="Regime Tributário"
                                        >
                                            <MenuItem value={""}>Nenhum</MenuItem>
                                            <MenuItem value={"simplesNacional"}>Simples Nacional</MenuItem>
                                            <MenuItem value={"simplesNacionalExcessoSublimite"}>Simples Nacional - Excesso Sublimite</MenuItem>
                                            <MenuItem value={"regimeNormal"}>Regime Normal</MenuItem>
                                            <MenuItem value={"simplesNacionalMEI"}>MEI (Microempreendedor Individual)</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth size="small" style={{ width: window.innerWidth < 600 ? '100%' : '49%' }} margin="dense">
                                        <InputLabel id="demo-simple-select-label">Incentivo Fiscal</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={false}
                                            label="Incentivo Fiscal"
                                            onChange={e => setIncentivoFiscal(e.target.value)}
                                        >
                                            <MenuItem value={true}>Sim</MenuItem>
                                            <MenuItem value={false}>Não</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, flexWrap: 'wrap' }}>
                                    <FormControl fullWidth size="small" style={{ width: window.innerWidth < 600 ? '100%' : '49%' }} margin="dense">
                                        <InputLabel id="demo-simple-select-label">Incentivo Fiscal Cultural</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={false}
                                            label="Incentivo Fiscal Cultural"
                                            onChange={e => setIncentivoFiscalCultural(e.target.value)}
                                        >
                                            <MenuItem value={true}>Sim</MenuItem>
                                            <MenuItem value={false}>Não</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth error={erroRegimeTributarioEspecial} size="small" required style={{ width: window.innerWidth < 600 ? '100%' : '49%' }} margin="dense">
                                        <InputLabel id="demo-simple-select-label">Regime tributário Especial</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={user?.empresa?.specialTaxRegime || ""}
                                            label="Regime tributário Especial"
                                            onChange={e => setRegimeTributarioEspecial(e.target.value)}
                                        >
                                            <MenuItem value={""}></MenuItem>
                                            <MenuItem value={"municipalMicroenterprise"}>Microempresa Municipal</MenuItem>
                                            <MenuItem value={"estimate"}>Estimativa</MenuItem>
                                            <MenuItem value={"societyOfProfessionals"}>Sociedade de Profissionais</MenuItem>
                                            <MenuItem value={"cooperative"}>Cooperativa</MenuItem>
                                            <MenuItem value={"individualMicroenterprise"}>Microempresário Individual (MEI)</MenuItem>
                                            <MenuItem value={"microenterpriseAndSmallBusiness"}>Microempresário e Empresa de Pequeno Porte (ME EPP)</MenuItem>
                                            <MenuItem value={"noSpecialRegime"}>Sem Regime Especial</MenuItem>
                                            <MenuItem value={"others"}>Outros</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, flexWrap: 'wrap' }}>
                                    <TextField style={{ width: window.innerWidth < 600 ? '100%' : '25%' }} value={MascaraCep(user?.empresa?.cep || "")} size="small" margin="dense" label="CEP" variant="outlined" placeholder="Digite o CEP" autoComplete="off" />
                                    <TextField style={{ width: window.innerWidth < 600 ? '100%' : '55%' }} disabled value={user?.empresa?.endereco || ""} size="small" margin="dense" label="Endereço" variant="outlined" placeholder="Digite o Endereço" autoComplete="off" />
                                    <TextField style={{ width: window.innerWidth < 600 ? '100%' : '18%' }} disabled value={user?.empresa?.numero || ""} size="small" margin="dense" label="Número" variant="outlined" placeholder="Digite o Número" autoComplete="off" />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, flexWrap: 'wrap' }}>
                                    <TextField style={{ width: window.innerWidth < 600 ? '100%' : '33%' }} disabled value={user?.empresa?.estado || ""} size="small" margin="dense" label="Estado" variant="outlined" placeholder="Digite o Estado" autoComplete="off" />
                                    <TextField style={{ width: window.innerWidth < 600 ? '100%' : '33%' }} disabled value={user?.empresa?.cidade || ""} size="small" margin="dense" label="Cidade" variant="outlined" placeholder="Digite a Cidade" autoComplete="off" />
                                    <TextField style={{ width: window.innerWidth < 600 ? '100%' : '33%' }} disabled value={user?.empresa?.bairro || ""} size="small" margin="dense" label="Bairro" variant="outlined" placeholder="Digite o Bairro" autoComplete="off" />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, flexWrap: 'wrap' }}>
                                    <TextField style={{ width: window.innerWidth < 600 ? '100%' : '60%' }} disabled value={user?.empresa?.email || ""} size="small" margin="dense" label="E-mail da Empresa" variant="outlined" placeholder="Digite o E-mail da Empresa" autoComplete="off" />
                                    <TextField style={{ width: window.innerWidth < 600 ? '100%' : '39%' }} value={MascaraTelefone(user?.empresa?.telefone || "")} size="small" margin="dense" label="Telefone da empresa" variant="outlined" placeholder="Digite o Telefone da empresa" autoComplete="off" />
                                </div>
                                {/* <FormGroup>
                                    <FormControlLabel control={<Checkbox checked={checkboxFatura} onChange={e => setCheckboxFatura(e.target.checked)} />} label="Gerar as faturas para este CNPJ?" />
                                </FormGroup> */}
                                {/* <Button
                                    fullWidth
                                    variant="contained"
                                    sx={{
                                        mt: 4,
                                        backgroundColor: "#901CB3",
                                        color: "white",
                                        fontWeight: 600,
                                        "&:hover": { backgroundColor: "#701d8aff" },
                                    }}
                                >
                                    Salvar Dados da Empresa
                                </Button> */}
                            </Box>
                        </div>
                    </div>
                </Box>
            </Box>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <Loading open={open} />
            <AlertSuccess setOpenSnackbarSuccess={setOpenSnackbarSuccess} openSnackbarSuccess={openSnackbarSuccess} mensagem={mensagem} />
            <AlertError setOpenSnackbarError={setOpenSnackbarError} openSnackbarError={openSnackbarError} mensagem={mensagem} />
        </>
    );
};

export default Certificado;